import { Modal, PDFRenderer } from "components";
import config from "config";
import { useAppLocation, useAppSearch } from "_graphql/cache/auth";

export default function ViewNoteContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const searchParams = useAppSearch();
  const { params } = useAppLocation();

  const url = `${config.asset.uri}generate_endorsement_closing/${btoa(
    JSON.stringify({
      offer_participant_id: searchParams?.id || "",
      endorsement_id: params?.endorsement || "",
    })
  )}`;

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      hideActions
      size="6xl"
      title="Endorsement Closing Note"
      description="View Endorsement Closing Note"
    >
      <PDFRenderer url={url} />
    </Modal>
  );
}
